import React from "react";

import { useTranslation } from "react-i18next";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import colors from "../../../../../assets/theme/base/colors";

const EmptyAsset = ({ onAddAsset }) => {
	const { t } = useTranslation();
	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100%", // Adjust height as needed

				// borderRadius: "8px",
				backgroundColor: "#fafafa", // Light background
				padding: "20px",
				mx: 2
			}}
		>
			{/* Placeholder for the icon (like the one in the image) */}
			<Box>
				<AttachFileIcon />
			</Box>

			{/* "No files yet. Upload one!" text */}
			<Typography
				variant="h6"
				sx={{
					fontWeight: "bold",
					color: "#333",
					marginBottom: "8px"
				}}
			>
				{t("SOURCES.FOLDER.emptyDescription")}
			</Typography>

			{/* "Drag and drop or" text */}
			<Typography
				variant="body1"
				sx={{
					color: "#666",
					marginBottom: "16px"
				}}
			>
				{/* Drag and drop or */}
			</Typography>

			{/* Upload Button */}
			<Button
				variant="contained"
				startIcon={<CloudUploadIcon />}
				sx={{
					backgroundColor: colors.info.main, // Purple color similar to the image
					color: "#fff",
					textTransform: "none", // Prevent uppercase text
					padding: "8px 24px",
					borderRadius: "20px", // Rounded button
					"&:hover": {
						backgroundColor: colors.info.main // Slightly darker purple on hover
					}
				}}
				onClick={() => {
					onAddAsset?.();
				}}
			>
				{t("SOURCES.DRAG_DROP.title")}
			</Button>
		</Box>
	);
};

export default EmptyAsset;
